import { postHide } from '../api/postHide';

const setPostHide = (params) => {
    return async (dispatch, getState) => {
        try {
            await postHide(params);
            
        } catch(error) {
            if (error && error.response && error.response.status === 401) {
                localStorage.removeItem('token');
                window.location.replace(window.location.origin);
            }
        }
    }
}

export {
    setPostHide
}